<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1 ziro-report-content" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="34"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-collapsible-section-card
      [title]="'tkey;admin.tenant_management.config.details.title'"
      [isCollapsible]="false"
    >
      <ziro-text [fieldId]="'tenantName'"></ziro-text>
      <ziro-text [fieldId]="'tenantGuid'"></ziro-text>
      <ziro-text [fieldId]="'applicationGuid'"></ziro-text>
      <ziro-text [fieldId]="'applicationSecret'"></ziro-text>
      <ziro-select [fieldId]="'environmentType'"></ziro-select>
    </ziro-collapsible-section-card>

    @if (!isLoading && roleAndPermissionTableData?.length && !isTokenDetailsError) {
      <div class="mt-4 mb-5">
        <legend>{{ 'tkey;admin.tenant_management.roles_permissions.details.title' | translate }}</legend>
        <div class="alert alert-info">
          <div [innerHTML]="'tkey;admin.tenant_management.table.description' | escapeHtml"></div>
        </div>
        <table class="table mb-0" data-automation="roles-permissions-table">
          <thead class="table-dark">
            <tr class="row mx-0">
              <th class="col-2 col-xxl-3" scope="col">
                {{ 'tkey;admin.tenant_management.table.column_header_label.feature' | translate }}
              </th>
              <th class="col-4 col-xxl-3" scope="col">
                {{ 'tkey;admin.tenant_management.table.column_header_label.least_permissive_role' | translate }}
              </th>
              <th class="col-4 col-xxl-3" scope="col">
                {{ 'tkey;admin.tenant_management.table.column_header_label.higher_privileges' | translate }}
              </th>
              <th class="col-1 col-xxl-2" scope="col">
                {{ 'tkey;admin.tenant_management.table.column_header_label.required' | translate }}
              </th>
              <th class="col-1 col-xxl-1" scope="col">
                {{ 'tkey;admin.tenant_management.table.column_header_label.enabled' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of roleAndPermissionTableData; track row) {
              <tr class="row role-row mx-0 bg-white" [ngClass]="row.cssClass">
                <td data-automation="feature" class="col-2 col-xxl-3" [innerHTML]="row.feature | escapeHtml"></td>
                <td
                  data-automation="least-permissive-role"
                  class="col-4 col-xxl-3"
                  [innerHTML]="row.leastPermissiveRole | escapeHtml"
                ></td>
                <td
                  data-automation="higher-privileges"
                  class="col-4 col-xxl-3"
                  [innerHTML]="row.higherPrivileges | escapeHtml"
                ></td>
                <td data-automation="is-required" class="col-1 col-xxl-2" [innerHTML]="row.required | escapeHtml"></td>
                <td data-automation="is-enabled" class="col-1 col-xxl-1" [innerHTML]="row.enabled | escapeHtml"></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="mb-5">
        <legend>{{ 'tkey;admin.tenant_management.roles_permissions.current_graph_roles.title' | translate }}</legend>
        <div class="alert alert-info">
          <p class="mb-0">
            {{ 'tkey;admin.tenant_management.roles_permissions.current_graph_roles.description' | translate }}
          </p>
        </div>
        <table class="table mb-0" data-automation="graph-role-table">
          <thead class="table-dark">
            <tr class="row mx-0">
              <th class="col" scope="col">
                {{ 'tkey;admin.tenant_management.roles_permissions.current_graph_roles' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of currentRolesTableData; track row) {
              <tr class="row role-row mx-0 bg-white">
                <td data-automation="graph-role" class="col" [innerHTML]="row.graphRole | escapeHtml"></td>
              </tr>
            }
            @if (!currentRolesTableData.length) {
              <tr class="row role-row mx-0 table-warning">
                <td
                  data-automation="graph-role"
                  class="col text-center"
                  [innerHTML]="
                    'tkey;admin.tenant_management.roles_permissions.current_graph_roles.column_header.no_configured_roles'
                      | escapeHtml
                  "
                ></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (isTokenDetailsError) {
      <div
        class="alert alert-danger"
        data-automation="token-details-error-alert"
        [innerHTML]="'tkey;admin.tenant_management.roles_permissions.error' | escapeHtml"
      ></div>
    }

    @if (tenantId) {
      <div class="alert alert-info refresh-alert">
        {{ 'tkey;admin.powershell_management.refresh.alert.text' | translate }}
        <br />
        @if (!isRefreshing) {
          <a class="strong cache-refresh-link" (click)="refreshCache()" target="_blank">
            <i [ngClass]="ziroIcons.REFRESH"></i>
            {{ 'tkey;admin.powershell_management.refresh.link.text' | translate }}
          </a>
        }

        @if (isRefreshing) {
          <a class="strong text-warning disabled disabled-refresh-link" target="_blank">
            <i [ngClass]="ziroIcons.SAVING"></i>
            {{ 'tkey;admin.powershell_management.refreshing.link.text' | translate }}
          </a>
        }
      </div>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
